import React, {useState} from "react";
import {createPortal} from "react-dom";
import "./EllipsisText.css";

const TOOLTIP_GAP_PX = 4;

/** Text on one line, cut with an ellipsis; the full text shows in a tooltip while hovered. */
export default function EllipsisText({text, fallback = null, fill = false}) {
    const [tooltipPosition, setTooltipPosition] = useState(null);
    if (!text) {
        return fallback;
    }

    const showTooltip = event => {
        const rect = event.currentTarget.getBoundingClientRect();
        const top = rect.bottom + TOOLTIP_GAP_PX;
        // Anchor to whichever edge keeps the tooltip inside the viewport.
        setTooltipPosition(rect.left > window.innerWidth / 2
            ? {top, right: window.innerWidth - rect.right}
            : {top, left: rect.left});
    };

    return (
        <>
            <span className={fill ? "ellipsisText ellipsisTextFill" : "ellipsisText"}
                  onMouseEnter={showTooltip} onMouseLeave={() => setTooltipPosition(null)}>
                {text}
            </span>
            {tooltipPosition && createPortal(
                <div className="ellipsisTextTooltip" role="tooltip" style={tooltipPosition}>{text}</div>,
                document.body
            )}
        </>
    );
}
